var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_vm._t("contenidoTooltip",null,null,attrs)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.texto))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }